$(function () {
    $('.tab-item, ul.nav .nav-item').on('click', function (ev) {
        ev.preventDefault();
        const $this = $(this);
        if (!$this.is('.active')) {
            $this.siblings().children().removeClass('active');
            $this.children().addClass('active');
            const $widget = $this.closest('.tab-widget, .search-list');
            $widget.find('.tab-content, .tab-pane').removeClass('active');
            const target = $this.children('a').attr('href');
            if (target) {
                $widget.find(target).addClass('active');
            }
            if ($widget.data('secondary-control')) {
                const $second = $widget.data('secondary-control');
                if ($second.val() !== target) {
                    $second.val(target).change();
                }
            }
        }
    });
    // logic to ensure the ddl & the UL are in sync
    $('[data-secondary-tab-controller]').each(function () {
        const $this = $(this);
        const $widget = $this.closest('.tab-widget, .search-list');
        $widget.data('secondary-control', $this);
        $this.change(function () {
            $widget.find('[href="' + $this.val() + '"]').click();
        });
    });
});